import '../styles/components/page-heading.scss'

import React from 'react'

export const PageHeading: React.FC = ({ children }) => {
  return <h1 className="page-heading">{children}</h1>
}
